export const AUTH_TYPE = {
  LOGIN: "LOGIN",
  SIGN_UP: "SIGN_UP",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  CHANGE_PASSWORD: "CHANGE_PASSWORD"
}

export const LoginTypeEnum = {
  password: 1,
  sms: 2
}

// 注册暂时使用 login 枚举
export const SmsSendTypeEnum = {
  login: 4,
  register: 4,
  resetPassword: 2,
  setLoginPassword: 5
}

export const AUTH_ERROR_CODE = {
  MOBILE_NOT_REGISTER: "1004",
  MOBILE_ALREADY_REGISTER: "1008"
}

export const LOGIN_STEP = {
  LOGIN: "LOGIN",
  OTP_LOGIN: "OTP_LOGIN",
  OTP_SIGN_UP: "OTP_SIGN_UP",
  LINK_YUU: "LINK_YUU",
  UPDATE_PERSONAL_INFO: "UPDATE_PERSONAL_INFO"
}

export const LINK_YUU_TYPE = {
  SIGN_UP: 0,
  BIND_YUU: 1
}

export const LINK_YUU_ERROR_CODE = {
  REGISTER_MOBILE_DIFFERENT: "1101",
  REGISTER_YUUID_BIND_ANOTHER_MOBILE: "1102",
  REGISTER_MOBILE_HAS_BEEN_LOCKED: "1103",
  BIND_MOBILE_DIFFERENT: "1104",
  BIND_YUUID_BIND_ANOTHER_MOBILE: "1105",
  BIND_MOBILE_HAS_BEEN_LOCKED: "1106"
}
